import { render, staticRenderFns } from "./SortingLocationScan.vue?vue&type=template&id=fb2553a4&scoped=true&"
import script from "./SortingLocationScan.vue?vue&type=script&lang=js&"
export * from "./SortingLocationScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2553a4",
  null
  
)

export default component.exports